import {Map} from 'immutable';
import QuestionTypeStore from 'components/QuestionTypes/QuestionType.store';

import graphingQuestionActions from './GraphingQuestion.actions';

export default class GraphingQuestionStore extends QuestionTypeStore {
  constructor(name, questionId, question) {
    super(name);
    this.initialData = Map({
      guessEntities: [],
      questionId
    });
    this.setInitialData(this.initialData);
    this.writeData('__question', question);

    this.handleTargeted(
      graphingQuestionActions.SET_GUESS_ENTITIES,
      this.setProperty('guessEntities')
    );
  }

  getGuessEntities() {
    return this.readData('guessEntities');
  }

  buildGuessContent() {
    return {
      entities: this.getGuessEntities()
    };
  }
}
